module.exports = __webpack_public_path__ + "img/810-d1f47e.png";